import React from 'react';
import styled from 'styled-components';
import { SmallButton } from './styles';
import SignUpModal from './sign-up-modal';
import { useForm } from '../../../shared/form-validator-hook';

const Container = styled.div`
  margin: ${props => (props.theme.isMobile ? '146px 20px' : '175px auto 160px auto')};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => (!props.theme.isMobile && `
    width: 76vw;
    max-width: 1096px;
  `)};
  border-radius: 10px;
  background-color: ${props => props.theme.bodyColor};
  box-shadow: 0 3px 50px rgba(4, 26, 95, .4);
  padding: ${props => (props.theme.isMobile ? '72px 32px' : '85px 0')};
`;

const Desc = styled.p`
  margin: 0;
  margin-bottom: ${props => (props.theme.isMobile ? 48 : 34)}px;
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 32px;
  line-height: 42px;
  color: white;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  ${props => (props.theme.isMobile ? `
    flex-direction: column;
    align-items: center;
    width: 100%;
  ` : `
    width: 59.7vw;
    max-width: 716px;
    justify-content: center;
    &:after {
      content: "";
      max-width: 18px;
      width: 1.25vw;
    }
  `)};
`;

const Input = styled.input`
  &&&&& {
    order: -1;
    height: 50px;
    flex-grow: 1;
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightHeavy};
    font-size: 20px;
    line-height: 20px;
    color: white;
    background-color: ${props => props.theme.bodyColor};
    border: none;
    border-radius: 0;
    border-bottom: 1px solid ${props => props.theme.secondaryColor};

    &::placeholder {
      color: ${props => props.theme.secondaryColor};
    }
  }
`;

/* stylelint-disable selector-type-no-unknown */
const HelpBlock = styled.label`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 13px;
  color: ${props => props.theme.errorColor};

  ${Input}:not([data-error="show"]) + & {
    display: none;
  }
`;
/* stylelint-enable selector-type-no-unknown */

const InputContainer = styled.div`
  ${props => (props.theme.isMobile ? `
    flex-basis: 90px;
    width: 100%;
  ` : `
    max-width: 560px;
    flex-basis: 59.7vw;
    flex-grow: 1;
  `)};

  & > ${Input} {
    width: 100%;
  }
`;

const Button = styled(SmallButton)`
  order: 1;
  width: ${props => (props.theme.isMobile ? '100%' : '150px')};
  height: 50px;
  ${props => (props.theme.isMobile && `
    margin-top: 20px;
  `)};

`;

export default function JoinForm() {
  const {
    values, useInput, isValid, errors,
  } = useForm({ email: '' });
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  return (
    <Container id="join-free-form">
      <Desc>Join Livewire for free to access market insights</Desc>
      <Form>
        <InputContainer>
          <Input
            type="text"
            placeholder="Enter your email address"
            {...useInput('email', {
              isRequired: true,
              isEmail: true,
            })}
          />
          {errors.email && (
            <HelpBlock>
              {{
                isRequired: 'Email address is required',
                isEmail: 'Email address is invalid',
              }[errors.email]}
            </HelpBlock>
          )}
        </InputContainer>
        <Button
          type="button"
          disabled={!isValid}
          onClick={() => setIsModalVisible(true)}
        >
          join free
        </Button>
      </Form>
      <SignUpModal visible={isModalVisible} email={values.email} />
    </Container>
  );
}
